module.exports = __webpack_public_path__ + "img/NEU.3ecf7d0a.svg";